import React from 'react';
import { Box, Button } from '@mui/material';

interface PajamosTableProps {
  data?: {
    output?: {
      price?: string | number;
    };
  };
}

const PajamosTable = ({ data }: PajamosTableProps) => {
  const tabs = ['PAJAMOS', 'PLANAVIMAS', 'DOKUMENTAI (0)', 'SPEC. SĄLYGOS (0)', 'KROVINIAI', 'PELNINGUMAS', 'RIBOJIMAI'];
  const [_selectedTab, setSelectedTab] = React.useState(0);

  return (
    <Box
      sx={{
        width: '100%',
        border: '1px solid border.medium',
        fontSize: (theme: any) => theme.typography.fontSizes.small,
        fontWeight: 600,
      }}
    >
      {/* Tabs */}
      <Box
        sx={{
          display: 'flex',
          borderBottom: '1px solid border.dark',
          bgcolor: 'background.white',
          gap: 0.25,
          p: 0.25,
        }}
      >
        {tabs.map((tab, index) => (
          <Button
            key={tab}
            onClick={() => setSelectedTab(index)}
            sx={{
              px: 1,
              py: 0.5,
              border: '1px solid border.dark',
              bgcolor: 'background.white',
              color: (theme: any) => theme.palette.text.blue,
              fontWeight: 700,
              fontSize: (theme: any) => theme.typography.fontSizes.small,
              textTransform: 'none',
              minWidth: 'auto',
              '&:hover': {
                bgcolor: 'background.lightGrey',
              },
            }}
          >
            {tab}
          </Button>
        ))}
      </Box>

      {/* Header */}
      <Box
        sx={{
          bgcolor: 'background.shadowBlack',
          color: 'text.white',
          px: 1.5,
          py: 1,
          fontWeight: 700,
          fontSize: (theme: any) => theme.typography.fontSizes.body,
        }}
      >
        PAJAMOS {data?.output?.price}
      </Box>

      {/* Column Headers as single line of text */}
      <Box sx={{ overflowX: 'auto' }}>
        <Box
          sx={{
            bgcolor: 'background.shadowBlack',
            color: 'text.white',
            px: 1.5,
            py: 1,
            width: '100%',
            fontSize: (theme: any) => theme.typography.fontSizes.body,
            textTransform: 'uppercase',
            fontWeight: 700,
            whiteSpace: 'nowrap',
          }}
        >
          <Box component="span" sx={{ display: 'inline-block', mr: 1, verticalAlign: 'middle' }}>
            ＋
          </Box>
          PARTNERIS PASLAUGA PAVADINIMAS MATO VNT. KIEKIS KAINA NUOLAIDA SUMA SUMA SU PVM VALIUTA PVM TARIFAS ĮMONĖ GRUPĖ GRUPUOTI APMOKESTINAMA MARŽA KOREGAVIMAS SĄSKAITA PASTABOS PVM% ATSAKINGAS ĮVEDĖ ĮV. DATA KEITĖ KEIT. DATA
        </Box>
      </Box>
    </Box>
  );
};

export default PajamosTable;
